import { type PropsWithChildren } from 'react';

import { type MessageDescriptor } from 'react-intl-next';

export type VideoPlayerModalProps = PropsWithChildren<{
	/**
	 * A `testId` prop is provided for specified elements, which is a unique
	 * string that appears as a data attribute `data-testid` in the rendered code,
	 * serving as a hook for automated tests */
	testId?: string;

	/**
	 * Width of VideoPlayerModal. Default values are '400px' for docked/default modes and '620px' for expanded mode
	 */
	width?: string;

	expandedWidth?: string;
	defaultMode?: ModalMode;
	analyticsProduct: string;
	analyticsClient: any;
	title: MessageDescriptor;
	url?: string;
	onClose: () => void;
	onModeChange?: (mode: ModalMode) => void;
}>;

export enum ModalMode {
	DOCKED = 'docked',
	DEFAULT = 'default',
	EXPANDED = 'expanded',
}

export type PRODUCT_TYPE = 'confluence' | 'jira';
